module.exports = __webpack_public_path__ + "img/img-5.92991671.png";